import _ from 'lodash'
import { Palette } from '@core/theme/color-palette-siteassist'
import { localizedStrings } from '@core/strings'

export type Priority = 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL'

export const PRIORITIES_ALL: Priority[] = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL']

export const PriorityHelpers = {
  getLabel: (priority: Priority) => {
    const labelsMap: Record<Priority, string> = {
      LOW: localizedStrings.low,
      MEDIUM: localizedStrings.medium,
      HIGH: localizedStrings.high,
      CRITICAL: localizedStrings.critical,
    }

    return labelsMap[priority] ?? _.capitalize(priority)
  },

  getColor: (priority: Priority) => {
    const colorsMap: Record<Priority, string> = {
      LOW: Palette.Green[400],
      MEDIUM: Palette.Yellow[500],
      HIGH: Palette.Orange[500],
      CRITICAL: Palette.Red[500],
    }

    return colorsMap[priority] ?? Palette.Green[400]
  },

  getBorderColor: (priority: Priority) => {
    const borderColorsMap: Record<Priority, string> = {
      LOW: Palette.Green[500],
      MEDIUM: Palette.Yellow[600],
      HIGH: Palette.Orange[600],
      CRITICAL: Palette.Red[600],
    }

    return borderColorsMap[priority] ?? Palette.Green[500]
  },

  hasDarkColor: (priority: Priority) => {
    return priority !== 'MEDIUM'
  },

  isPriorityQuestion: (question: {
    questionType: string
    answers?: Array<{ value?: string }>
  }) => {
    const options = question.answers ?? []

    return (
      question.questionType === 'MULTIPLE_CHOICE' &&
      options.length > 0 &&
      options.every((answer) =>
        PRIORITIES_ALL.includes(answer.value?.toUpperCase?.() as Priority),
      )
    )
  },
}
